<template>
    <v-container>
        <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="mx-auto px-2 pt-2">
            <v-toolbar flat dark class="indigo lighten-3">
                <v-toolbar-title>Equipment Control</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-breadcrumbs :items="$store.state.routes" divider=" | "></v-breadcrumbs>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    hide-default-footer
                    :items-per-page="itemsPerPage"
                    fixed-header
                    height="50vh"                    
                >
                    <template v-slot:top>
                        <v-tabs
                            v-model="tab"
                            center-active
                            dark
                        >
                            <v-tabs-slider color="yellow"></v-tabs-slider>
                                <v-tab
                                    v-for="(destination, i) in destinations"
                                    :key="destination.destination_id"
                                    :value="destination.destination_id"
                                >
                                    {{destination.destination_type}}({{destination.destination_id}})
                                </v-tab>
                        </v-tabs>
                        <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-magnify"
                            label="Search Container#..."
                            placeholder="Search Container#..."
                            v-model="search"
                            class="mt-2"
                            @keyup="searchByKeyword()"
                        ></v-text-field>
                        <v-select
                            outlined
                            dense
                            label="Status"
                            :items="statuses"
                            v-model="status"
                        ></v-select>
                        <!--Data Picker start-->
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            @input="onMenuChange"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-if="['su', 'surveyor', 'admin', 'mnr'].includes($store.state.user.role)"
                                    v-model="dateRangeText"
                                    label="Date Range"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dates"
                                range
                            ></v-date-picker>
                        </v-menu>
                        <!--Data Picker finish-->
                        <p># of records: <span style="color: red; font-weight: bold;">{{totalNumberOfRecords}}</span></p>
                        <p>Damages: <v-badge color="red" content="DA:"></v-badge></p>
                        <p>JobOrderServices: <v-badge color="blue" content="JOS:"></v-badge></p>
                        <div>
                        <v-pagination
                                v-model="page"
                                :length="pageCount"
                                total-visible="10"
                                dark
                                @input="changePage()"
                            ></v-pagination>
                        </div>                         
                    </template>
                    <!-- <template v-slot:[`item.gate_in_at`]="{ item }">
                        <div v-if="!item.gate_in_at">
                            <v-btn
                                color="orange"
                                dark
                                small
                                @click="gateIn(item)"
                            >
                            <v-icon>mdi-boom-gate-arrow-up</v-icon> Gate In
                        </v-btn>
                        </div>
                        <div v-else>
                            {{item.gate_in_at}}
                        </div>
                    </template> -->
                    <template v-slot:[`item.back_to_survey`]="{ item }">
                        <v-badge
                        :content="'DA:' + item.damages.length"
                        color="red"
                        overlap
                        :offset-x="90"
                        :offset-y="5"                        
                        >                        
                        <v-badge
                            :content="'JOS:' + item.job_order_services.length"
                            color="blue"
                            overlap
                            :offset-x="40"
                            :offset-y="5"                            
                        >
                            <v-btn
                                    color="orange"
                                    dark
                                    small
                                    :disabled="item.gate_out_at != null && !$store.state.user.role.match(/^su$|^ec$/)"
                                    @click="backToSurvey(item)"
                                >
                                <v-icon>mdi-magnify-expand</v-icon> Back to Survey
                            </v-btn>
                        </v-badge>
                        </v-badge>
                    </template>
                    <!-- <template v-slot:[`item.job_started_at`]="{ item }">
                        <div v-if="!item.job_started_at">
                            <v-btn
                                color="orange"
                                dark
                                small
                                :to="`/damage_list/${item.transaction_id}/${item.container_number}/${item.survey_id}/${item.job_order_id}/${tab}`"
                                :disabled="!item.gate_in_at"
                            >
                                <v-icon>mdi-play-circle</v-icon> Start Job
                            </v-btn>
                        </div>
                        <div v-else>
                            <div v-if="item.job_closed_at">
                                {{ item.job_started_at }}
                            </div>
                            <div v-else>
                                <a :href="`/damage_list/${item.transaction_id}/${item.container_number}/${item.survey_id}/${item.job_order_id}/${tab}`">{{ item.job_started_at }}</a>
                            </div>
                        </div>
                    </template> -->
                    <!-- <template v-slot:[`item.job_closed_at`]="{ item }">
                        <div v-if="!item.job_closed_at">
                        -
                        </div>
                        <div v-else>
                            {{item.job_closed_at}}
                        </div>
                    </template> -->
                    <!-- <template v-slot:[`item.gate_out_at`]="{ item }">
                        <div v-if="!item.gate_out_at">
                            <v-btn
                                color="orange"
                                dark
                                small
                                @click="gateOut(item)"
                                :disabled="!item.job_closed_at"
                            >
                            <v-icon>mdi-boom-gate-arrow-down</v-icon> Gate Out
                        </v-btn>
                        </div>
                        <div v-else>
                            {{item.gate_out_at}}
                        </div>
                    </template> -->
                </v-data-table>
                <div class="text-center pt-2">
                        <v-pagination
                            v-model="page"
                            :length="pageCount"
                            total-visible="10"
                            dark
                            @input="changePage()"
                        ></v-pagination>
                    </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            menu: false,
            dates: [
                `${moment().format('YYYY')}-${moment().format('MM')}-01`,
                `${moment().format('YYYY')}-${moment().format('MM')}-${moment().daysInMonth()}`
            ],
            backupDates: [
                `${moment().format('YYYY')}-${moment().format('MM')}-01`,
                `${moment().format('YYYY')}-${moment().format('MM')}-${moment().daysInMonth()}`
            ],
            headers: [
                {
                    text: "JobOrderId",
                    value: "job_order_id",
                    sortable: false,
                },
                {
                    text: "TransactionId",
                    value: "transaction_id",
                    sortable: false,
                },
                {
                    text: "ContainerNumber",
                    value: "container_number",
                    sortable: false,
                },
                {
                    text: "ContainerType",
                    value: "transaction.type.type",
                    sortable: false,
                },
                {
                    text: "ContainerSize",
                    value: "transaction.size.size",
                    sortable: false,
                },
                {
                    text: 'Company',
                    value: 'transaction.company.name',
                    sortable: true,
                },                
                {
                    text: "SurveyId",
                    value: "survey_id",
                    sortable: false,
                },
                {
                    text: "Destination",
                    value: "transaction.destination.destination_type",
                    sortable: false,
                },
                {
                    text: "BackToSurvey",
                    value: "back_to_survey",
                    sortable: false,
                },
                {
                    text: "GateInAt",
                    value: "gate_in_at",
                    sortable: false,
                },
                {
                    text: "JobStartedAt",
                    value: "job_started_at",
                    sortable: false,
                },
                {
                    text: "JobClosedAt",
                    value: "job_closed_at",
                    sortable: false,
                },
                {
                    text: "GateOutAt",
                    value: "gate_out_at",
                    sortable: false,
                },
            ],
            items: [],
            containerNumber: null,
            transactionId: null,
            surveyId: null,
            search: null,
            jobOrderServiceDialog: false,
            tab: 0,
            pageCount: 0,
            page: 1,
            itemsPerPage: 30,
            totalNumberOfRecords: null,
            part_names: [],
            partName: [],
            descriptions: [],
            description: null,
            locations: [],
            location: null,
            way_of_repairs: [],
            wayOfRepair: null,
            serviceId: null,
            openEncodeJobOrderServicesDialog: false,
            currentJobOrder: null,
            currentJobOrderServiceId: null,
            currentJobOrderId: null,
            currentDamage: null,
            jobOrderServices: [],
            destinations: [],
            postServicePicturesUploadingDialog: false,
            userFiles: [],
            progressLinear: null,
            formData: null,
            postServicePictureHeaders: [
                {
                    text: 'TransactionId',
                    value: 'transaction_id',
                    sortable: true,
                },
                {
                    text: 'ContainerNumber',
                    value: 'container_number',
                    sortable: true,
                },
                {
                    text: 'FileName',
                    value: 'file_name',
                    sortable: true,
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                }
            ],
            postServicePictures: [],
            status: 'All',
            statuses: [
                'All',
                'Surveyed',
                'Job Closed',
                'Gate Out'
            ],
        }
    },
    mounted() {
        if( !this.$store.state.user.role.match(/^su$|admin|ec/) ) {
            alert('You have not access right to enter the area...');
            this.$router.push('/');
        }

        if( this.$route.params.job_order_id && this.$route.params.tab ) {
            this.search = this.$route.params.job_order_id;
            this.tab = parseInt(this.$route.params.tab);
        } else if( !this.$route.params.job_order_id && this.$route.params.tab ) {
            this.tab = parseInt(this.$route.params.tab);
        } else {
            this.search = null;
            this.tab = 0;
        }
        // console.log(this.tab)
        this.getDestinations();
        this.getJobOrdersForEquipmentControl(this.tab);

        if( !this.$store.state.routes.some(obj => obj.href == this.$route.path) ) {
            this.$store.commit(
                'addRoute',
                {
                    text: this.$route.path,
                    disabled: false,
                    href: this.$route.path,                
                }            
            );        
        }
    },
    methods: {
        statusColor: function(status) {
            switch(status) {
                case 'Not Yet Fixed':
                return 'red';
                break;
                case 'Ongoing':
                return 'blue';
                break;
                case 'Fixed':
                return 'green';
                break;
            }
        },
        onMenuChange: function(val) {
            if (!val) {
                if (this.dates.length !== 2) {
                    this.dates = [...this.backupDates];
                } else {
                    this.backupDates = [...this.dates];
                }
            }
        },
        getJobOrdersForEquipmentControl: function(tab) {
            this.overlay = true;
            this.loading = true;
            // console.log(this.dates)
            this.axios.post(
                '/api/get_job_orders_for_equipment_control',
                {
                    tab: tab,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                    status: this.status,
                    dates: this.dates,
                    search: this.search,
                }
            ).then(response => {
                this.items = response.data.data;
                this.totalNumberOfRecords = response.data.total;
                this.pageCount = Math.ceil(response.data.total / this.itemsPerPage);
                // console.log(this.items)
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        getDamages: function(item) {
            this.axios.post(
                '/api/get_damages',
                {
                    transaction_id: item.transaction_id,
                    survey_id: item.survey_id,
                }
            ).then(response => {
                // console.log(response.data);
                this.damages = response.data;

                const unFixedDamages = this.damages.filter(function(value) {
                    return value.status_code != 'Fixed';
                });

                // console.log(this.damages)

                const postServicePictures = this.damages.filter(function(value) {
                    return value.picture.post_service_pictures.length > 0;
                });

                // console.log(postServicePictures);

                if( unFixedDamages.length == 0 && (postServicePictures.length >= this.damages.length ) ) {
                    this.canCloseJob = true;
                } else {
                    this.canCloseJob = false;
                }

            }).catch(error => {
                console.log(error);
            });
        },
        // gateIn: function(item) {
        //     this.overlay = true;
        //     this.loading = true;

        //     this.axios.post(
        //         '/api/gate_in',
        //         {
        //             job_order_id: item.job_order_id,
        //             user_id: this.$store.state.user.id,
        //         }
        //     ).then(response => {
        //         this.getJobOrders(this.tab);
        //     }).catch(error => {
        //         console.log(error);
        //     }).finally(() => {
        //         this.overlay = true;
        //         this.loading = true;
        //     });
        // },
        gateOut: function(item) {
            this.overlay = true;
            this.loading = true;

            this.axios.post(
                '/api/gate_out',
                {
                    job_order_id: item.job_order_id,
                    user_id: this.$store.state.user.id,
                }
            ).then(response => {
                this.getJobOrdersForEquipmentControl(this.tab);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = true;
                this.loading = true;
            });
        },
        startJob: function(item) {
            // this.jobOrderServiceDialog = true;
            // this.overlay = true;
            // this.loading = true;
            // this.currentJobOrder = item;
            // this.containerNumber = item.container_number;
            // this.transactionId = item.transaction_id;

            // this.axios.post('/api/get_part_names')
            //     .then(response => {
            //         // console.log(response.data)
            //         if(response.status === 200) {
            //             this.part_names = response.data;
            //         }
            //     }).catch(error => {
            //         console.log(error);
            //     }).finally(() => {
            //         this.overlay = false;
            //         this.loading = false;
            //     });
            // this.getDamages(item);

            // this.overlay = true;
            // this.loading = true;

            // this.axios.post(
            //     '/api/start_job',
            //     {
            //         job_order_id: item.job_order_id
            //     }
            // ).then(response => {
            //     this.getJobOrders();
            // }).catch(error => {
            //     console.log(error);
            // }).finally(() => {
            //     this.overlay = true;
            //     this.loading = true;
            // });
        },
        uploadPictures: function(item) {
            // console.log(item)
            // ここに画像アップロードフォームを開くコードを含む。
            this.postServicePicturesUploadingDialog = true;
            this.containerNumber = item.container_number;
            this.transactionId = item.transaction_id;
            this.currentJobOrderId = item.job_order_id;
        },
        addFiles: function() {
            this.formData = new FormData();

            if( typeof this.userFiles === 'undefined' || this.userFiles.length === 0 ) {
                return false;
            }

            for(var file of this.userFiles) {
                if( typeof file === 'undefined' ) {
                    return false;
                }
                if (!file.name.match(/png|jpg$/i)) {
                    const payload = {
                        title: "Invalid file chosen..",
                        msg: "You tried to upload invalid type of file...you can upload png/jpg only..",
                    };
                    this.$store.commit("showAlert", payload);
                    return false;
                } else {
                    this.formData.append("file", file);
                }
            }

            this.formData.append("user_id", this.$store.state.user.id);
            this.formData.append('container_number', this.containerNumber);
            this.formData.append('transaction_id', this.transactionId);
            this.formData.append('picture_id', this.currentDamage.picture_id);
            this.formData.append('filename', this.currentDamage.picture.file_name);
            this.formData.append('job_order_service_id', this.currentJobOrderServiceId);
            this.formData.append('seq_no', this.postServicePictures.length + 1);

            this.overlay = true;
            this.loading = true;

            this.axios
                .post(
                "/api/save_post_service_file",
                this.formData,
                // {
                //     onUploadProgress: this.onUpload,
                // },
                {
                    headers: {
                    "Content-Type": "multipart/form-data",
                    },
                }
                )
                .then((response) => {
                if (response.status === 200) {
                    // this.areas.splice(this.areas.indexOf(a), 1);
                    // this.userFiles.splice(i, 1);
                    // this.progressLinears.splice(i, 1);
                    this.userFiles = [];
                    this.getPostServicePictures(this.currentJobOrderServiceId);
                    this.getJobOrderServicesByDamageId();
                    this.getDamages(this.currentJobOrder);
                }
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        // onUpload: function (e) {
        //     this.$set(
        //         this.progressLinear,
        //         0,
        //         Math.floor((e.loaded / e.total) * 100)
        //     );
        // },
        getJobOrderServicesByDamageId: function() {
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/get_job_order_services_by_damage_id',
                {
                    job_order_id: this.currentJobOrder.job_order_id,
                    damage_id: this.currentDamage.damage_id,
                }
            ).then(response => {
                // console.log(response.data);
                this.jobOrderServices = response.data;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        getPostServicePictures: function(job_order_service_id) {
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/get_post_service_pictures',
                {
                    job_order_service_id: job_order_service_id,
                }
            ).then(response => {
                if(response.status === 200) {
                    this.postServicePictures = response.data;

                }
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        deletePostServicePicture: function(item) {
            if(!confirm('Is it ok to delete the picture?')) {
                return false;
            }
            this.overlay = true;
            this.loading = true;
            this.axios.post(
                '/api/delete_post_service_picture',
                {
                    id: item.id,
                    container_number: item.container_number,
                    transaction_id: item.transaction_id,
                    file_name: item.file_name,
                }
            ).then(response => {
                // console.log(response.data);
                if(response.status === 200) {
                    const payload = {
                        title: "Picture deleted",
                        msg: "The picture data has been successfully deleted...",
                    };
                    this.$store.commit("showAlert", payload);
                    this.getPostServicePictures(this.currentJobOrderServiceId);
                    this.getJobOrderServicesByDamageId();
                    this.getDamages(this.currentJobOrder);
                }
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = false;
                this.loading = false;
            });
        },
        viewPostServicePicture: function(item) {
            this.overlay = true;
            this.downloading = true;
            axios
                .post(
                    "/api/view_post_service_picture",
                    {
                        transaction_id: this.transactionId,
                        container_number: this.containerNumber,
                        file_name: item.file_name,
                    },
                    {
                        responseType: "blob",
                    }
                )
                .then(response => {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data], { type: "image/png" })
                    );
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.target = "_blank";
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    document.body.removeChild(fileLink);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.downloading = false;
                    this.overlay = false;
                });
        },
        backToSurvey: function(item) {
            // console.log(item)
            // return false;
            // this.$router.push('/surveys');
            this.overlay = true;
            this.downloading = true;
            axios
                .post(
                    "/api/back_to_survey",
                    {
                        survey_id: item.survey_id,
                    }
                )
                .then(response => {
                    if(response.status === 200) {
                        // console.log(response.data);
                        // return false;
                        this.$router.push('/survey/3/' + item.transaction_id);
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.downloading = false;
                    this.overlay = false;
                });
        },
        closeJob: function() {
            this.overlay = true;
            this.loading = true;

            this.axios.post(
                '/api/close_job',
                {
                    job_order_id: this.currentJobOrder.job_order_id,
                    user_id: this.$store.state.user.id,
                }
            ).then(response => {
                this.getJobOrdersForEquipmentControl(this.tab);
                this.jobOrderServiceDialog = false;
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.overlay = true;
                this.loading = true;
            });
        },
        changePage: function() {
            this.getJobOrdersForEquipmentControl(this.tab);
        },
        getDestinations: function() {
            this.overlay = true;
            this.loading = true;
            this.axios.post('/api/get_destinations')
                .then(response => {
                    this.destinations = response.data;
                    // console.log(this.destinations);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.overlay = false;
                    this.loading = false;
                });
        },
        searchByKeyword: function() {
            this.getJobOrdersForEquipmentControl(this.tab);
        }
    },

    filters: {
        formatDate: function (date) {
            return date !== null ? moment(date).format("MM-DD-YYYY hh:mm:ss A") : '';
        },
    },
    watch: {
        tab: function() {
            this.getJobOrdersForEquipmentControl(this.tab);
        },
        status: function() {
            this.getJobOrdersForEquipmentControl(this.tab);
        },
        dates: function() {
            if (this.dates.length == 0 && this.dates.length == 1) {
                return false;
            } else if (this.dates.length == 2) {
                if ( this.dates[0] > this.dates[1] ) {
                    alert('Invalid date selection');
                    this.dates = [];
                    return false;
                } else {
                    this.page = 1;
                    this.getJobOrdersForEquipmentControl(this.tab);
                }
            }
        }
    },
    computed: {
        dateRangeText() {
            return this.dates.join(' ~ ');
        }
    },
}
</script>
